import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import type { LegendItem } from "@answersnow/pkg-theme";

import { space7 } from "../styled";

interface AssessmentChartLegendRowProps {
  items: LegendItem[];
}

export default function AssessmentChartLegendRow({ items }: AssessmentChartLegendRowProps) {
  if (!items.length) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={space7} justifyContent="center">
      {items.map((item) => (
        <Stack key={item.label} direction="row" alignItems="center" spacing={1}>
          {item.marker === "line" ? (
            <Box
              sx={{
                width: 16,
                height: 2,
                borderRadius: 1,
                backgroundColor: item.color,
              }}
            />
          ) : (
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "999px",
                backgroundColor: item.color,
              }}
            />
          )}
          <Typography variant="body2" color="text.secondary">
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
